export default "__VITE_ASSET__EhNZPTAk__"